import { exportListToExcel } from "../../stock/components/list/listExportUtils";
import { groupByCustomer, shortDate } from "./dutyListModel";
import { VIEW_TITLES } from "./DutyListPrintPreview";

// Excel for whichever Duty List view is open (the WinForms PRINT button was
// in fact an Excel export of the grid). Flat rows with the customer on every
// line, so the sheet can be sorted and filtered in Excel.
export const exportDutyListExcel = ({ view, data, rows, summary, guardRows, newRows, blankRows, subtitle, blankWindowText, companyName }) => {
  let columns;
  let list;
  if (view === "detail") {
    const days = Array.from({ length: data.daysInMonth }, (_, i) => i + 1);
    list = groupByCustomer(rows).flatMap((g) => g.rows);
    columns = [
      { header: "Customer", value: (r) => r.custName },
      { header: "Area", value: (r) => r.area },
      { header: "Assignment", value: (r) => r.assignmentName },
      { header: "Shift", value: (r) => r.shift },
      { header: "Temp", value: (r) => (r.isTemp ? "Temp" : "") },
      ...days.map((d) => ({ header: String(d), value: (r) => (r.codes[d - 1] != null ? Number(r.codes[d - 1]) : "") })),
      { header: "Days", value: (r) => r.filledDays },
      { header: "Blank", value: (r) => r.blankDays },
    ];
  } else if (view === "summary") {
    list = summary;
    columns = [
      { header: "Customer", value: (s) => s.custName },
      { header: "Area", value: (s) => s.areas },
      { header: "Day posts", value: (s) => s.daySlots },
      { header: "Night posts", value: (s) => s.nightSlots },
      { header: "Permanent posts", value: (s) => s.permSlots },
      { header: "Temp posts", value: (s) => s.tempSlots },
      { header: "Full month Day", value: (s) => s.fullDayText },
      { header: "Full month Night", value: (s) => s.fullNightText },
      { header: "Part month - why", value: (s) => s.partMonthText },
      { header: "Day shifts", value: (s) => s.dayShifts },
      { header: "Night shifts", value: (s) => s.nightShifts },
      { header: "Blank shifts", value: (s) => s.blankShifts },
      { header: "Staff used", value: (s) => s.guards },
    ];
  } else if (view === "guards") {
    list = guardRows;
    columns = [
      { header: "Code", value: (g) => g.empCode },
      { header: "Employee", value: (g) => g.name },
      { header: "Day shifts", value: (g) => g.dayShifts },
      { header: "Night shifts", value: (g) => g.nightShifts },
      { header: "Total", value: (g) => g.total },
      { header: "Customers", value: (g) => g.customerList },
    ];
  } else if (view === "new") {
    list = newRows;
    columns = [
      { header: "Customer", value: (r) => r.custName },
      { header: "Area", value: (r) => r.area },
      { header: "Assignment", value: (r) => r.assignmentName },
      { header: "Shift", value: (r) => r.shift },
      { header: "From", value: (r) => shortDate(r.fromDate) },
      { header: "To", value: (r) => (r.toDate ? shortDate(r.toDate) : "UFN") },
      { header: "Temp", value: (r) => (r.isTemp ? "Temp" : "") },
      { header: "Active", value: (r) => (r.isActive ? "Yes" : "No") },
      { header: "Days worked", value: (r) => r.filledDays },
    ];
  } else {
    list = blankRows;
    columns = [
      { header: "Customer", value: (r) => r.custName },
      { header: "Area", value: (r) => r.area },
      { header: "Assignment", value: (r) => r.assignmentName },
      { header: "Shift", value: (r) => r.shift },
      { header: "Blank", value: (r) => r.blankInWindow.length },
      { header: "Dates", value: (r) => r.blankLabel },
    ];
  }

  exportListToExcel({
    title: VIEW_TITLES[view],
    subtitleLines: view === "blank" ? [subtitle, blankWindowText] : [subtitle],
    ...(companyName ? { companyName } : {}),
    columns,
    rows: list,
    fileName: `${VIEW_TITLES[view]} ${data.year}-${String(data.month).padStart(2, "0")}`,
  });
};
